import { createReducer, on } from '@ngrx/store';
import {
  ConfirmationPageActions,
  ReviewPageActions,
  TransactionFormActions,
} from '../../create-request/actions';
import {
  StandingAuthConfirmationPageActions,
  StandingAuthFormActions,
  StandingAuthReviewPageActions,
} from '../../standing-authorizations/actions';
import { ViewPageActions } from '../../transaction-view/actions';

export const pageScrollToKey = 'scrollTo';

export const initialPageScrollToState: string = '';

export const pageScrollToStateReducer = createReducer(
  initialPageScrollToState,
  on(TransactionFormActions.loadReviewPage,
    () => {
      return 'review-page-header';
    }
  ),
  on(StandingAuthFormActions.loadReviewPage,
    () => {
      return 'sa-review-page-header';
    }
  ),
  on(ReviewPageActions.loadConfirmationPage,
    ReviewPageActions.loadConfirmationPageWithoutAcknowledgeCall,
    () => {
    return 'confirmation-page-header';
  }),
  on(StandingAuthReviewPageActions.loadConfirmationPage,
    StandingAuthReviewPageActions.loadEmptyConfirmationPage,
    () => {
    return 'sa-confirmation-page-header';
  }),
  on(
    ReviewPageActions.editClicked,
    StandingAuthReviewPageActions.editClicked,
    () => {
      return 'transaction-form-header';
    }
  ),
  on(
    ReviewPageActions.cancelClicked,
    StandingAuthReviewPageActions.cancelClicked,
    () => {
      return 'transaction-form-header';
    }
  ),
  on(ConfirmationPageActions.createAnotherRequestClicked,
    StandingAuthConfirmationPageActions.createNewStandingAuthClicked,
    ViewPageActions.editButtonClicked,
    ViewPageActions.startTransactionButtonClicked,
    StandingAuthConfirmationPageActions.returnStandingAuthClicked,
    () => {
    return 'transaction-form-header';
  }),
  on(ConfirmationPageActions.viewTransactionStatusClicked, () => {
    return 'account-transactions-header';
  })
);
